import { useDispatch, useSelector } from "react-redux";
import cms from "../../../constants/cmskeys";
import { changeFax, changeIsCheckedFax } from "../../../redux/Slices/FaxSlice";
import cmsParser from "../../Services/CMSParser";

const Fax = ({ cmsLabels }) => {
    const dispatch = useDispatch();
    const { fax, isCheckedFax } = useSelector((state) => state.fax);

    return (
        <div className="dds__py-2 dds__border-top">
            <div className="dds__checkbox" role="checkbox">
                <label className="dds__checkbox__label dds__w-100" htmlFor="lrFaxCheck">
                    <input
                        className="dds__checkbox__input"
                        type="checkbox"
                        name="lrFaxCheck"
                        id="lrFaxCheck"
                        value="lg"
                        onChange={() => dispatch(changeIsCheckedFax(!isCheckedFax))}
                    />
                    <span tabIndex="-1">{cmsParser(cms.Fax, cmsLabels)}</span>
                </label>
            </div>
            <div
                className={
                    "dds__py-4 dds__px-5 dds__d-none " +
                    (isCheckedFax ? "dds__d-block" : "dds__d-none")
                }
            >
                <div className="dds__row">
                    <div className="dds__col--lg-8 dds__col--xl-6">
                        <div className="dds__input-text__container dds__row dds__align-items-center">
                            <div className="dds__col--md-4 dds__text-md-right">
                                <label id="lblLRFax" htmlFor="txtLRFax">
                                    {cmsParser(cms.Fax_Number, cmsLabels)}
                                </label>
                            </div>
                            <div className="dds__col--md-8">
                                <div className="dds__input-text__wrapper dds__flex-grow-1 dds__pl-md-2">
                                    <input
                                        type="text"
                                        className="dds__input-text"
                                        maxLength="30"
                                        name="txtLRFax"
                                        id="txtLRFax"
                                        required=""
                                        aria-labelledby="lblLRFax"
                                        onChange={(e) => dispatch(changeFax(e.target.value))}
                                        value={fax}
                                    />
                                    <div
                                        id="sample-input-feedback"
                                        className="dds__invalid-feedback"
                                    >
                                        {cmsParser(cms.validation_fax, cmsLabels)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Fax;
